import { useEffect, useState } from "react";
import { Percent } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { setRates, useRates } from "@/lib/pricing";

const num = "w-full min-w-0 rounded-xl border border-white/10 bg-white/5 px-3 py-2 text-right text-sm text-white outline-none focus:border-white/40";

export const CardRatesTable = () => {
  const rates = useRates();
  const [draft, setDraft] = useState(() => rates.map(String));
  const [saving, setSaving] = useState(false);

  useEffect(() => { setDraft(rates.map(String)); }, [rates]);

  const save = async () => {
    const list = draft.map((v) => Number(String(v).replace(",", ".")));
    if (list.some((v) => !Number.isFinite(v) || v < 0 || v >= 60)) {
      toast.error("Confira as taxas: use números entre 0 e 60.");
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put("/admin/card-rates", { rates: list });
      setRates(data?.rates);
      toast.success("Taxas salvas");
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section data-testid="admin-card-rates" className="mt-8 rounded-[24px] border border-white/10 bg-[#111113] p-5 sm:p-6">
      <div className="flex items-center gap-2.5">
        <Percent className="h-5 w-5 text-white" />
        <h2 className="font-display text-xl font-bold">Taxas da maquininha</h2>
      </div>
      <p className="mt-2 text-sm text-zinc-400">Taxa (%) de cada parcela no crédito. A taxa é repassada ao cliente para você receber o preço cheio: parcela = preço ÷ (1 − taxa) ÷ nº de parcelas. Vale para o simulador, os cards e o WhatsApp.</p>
      <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3 lg:grid-cols-4">
        {draft.map((v, i) => (
          <label key={i} className="flex items-center gap-2 text-sm">
            <span className="w-16 shrink-0 text-zinc-300">{i + 1}x</span>
            <input data-testid={`card-rate-${i + 1}x`} inputMode="decimal" value={v}
              onChange={(e) => setDraft((d) => d.map((x, j) => (j === i ? e.target.value : x)))} className={num} />
            <span className="text-zinc-400">%</span>
          </label>
        ))}
      </div>
      <button data-testid="card-rates-save" onClick={save} disabled={saving}
        className="mt-5 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-black transition-transform hover:scale-[1.02] disabled:opacity-60">
        {saving ? "Salvando…" : "Salvar taxas"}
      </button>
    </section>
  );
};
